export default __webpack_public_path__ + "static/media/yeopen_mobile@2x.69737ee7.jpg";